import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import StudentSidebar from '../../StudentSidebar/StudentSidebar'
import { getStudentStudyMaterialVideoListData } from '../../../../Redux/action/StudentAction';
import Beatloader from '../../../../Common/BeatLoader';
import ResponsivePagination from '../../../../Common/Pagination';



const host = process.env.REACT_APP_API_SERVER
const StudentVideoNotes = () => {
    const [video, setVideo] = useState();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getStudentStudyMaterialVideoListData())


    }, []);
    const {
        loadingStudentStudyMaterialVideoListApi,
        StudentStudyMaterialVideoListApiData,
        StudentStudyMaterialVideoListApiError

    } = useSelector(state => state?.StudentReducer);
    const handleVideoClick = (v) => {

        const pathParts = v.split('/');
        const fileName = pathParts.pop();
        const encodedFileName = encodeURIComponent(fileName);
        const enc = `${host}${pathParts.join('/')}/${encodedFileName}`
        setVideo(enc)

    }

    //pagination


    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!StudentStudyMaterialVideoListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(StudentStudyMaterialVideoListApiData.slice(start, end));
        setPageCount(Math.ceil(StudentStudyMaterialVideoListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, StudentStudyMaterialVideoListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <a href="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </a>
                            &nbsp;&nbsp;Notes & Handouts
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <StudentSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="my-student-sec">
                                    {/* <h1>Video Lessons</h1> */}
                                    {/* <ul class="nav nav-tabs my-student-nav-sec" id="myTab" role="tablist">
                          <li class="nav-item" role="presentation">
                              <button class="nav-link active" id="home-tab" data-bs-toggle="tab"
                                  data-bs-target="#home" type="button" role="tab" aria-controls="home"
                                  aria-selected="true">One To One</button>
                          </li>
                          <li class="nav-item" role="presentation">
                              <button class="nav-link" id="profile-tab" data-bs-toggle="tab"
                                  data-bs-target="#profile" type="button" role="tab" aria-controls="profile"
                                  aria-selected="false">Group Courses</button>
                          </li>
                      </ul> */}
                                    {/* <div className="browse-tutor">
                                        <div className="row">
                                            <div className="col-lg-4 offset-lg-6">
                                                <input
                                                    type="text"
                                                    placeholder="Search video"
                                                    className="input-card-form"
                                                    required=""
                                                />
                                            </div>
                                            <div className="col-lg-2">
                                                <a href="">
                                                    <button className="btn btn-primary w-100">search</button>
                                                </a>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="tab-content-student my-student-tab-pane" id="myTabContent">
                                        <div
                                            className="tab-pane fade show active"
                                            id="home"
                                            role="tabpanel"
                                            aria-labelledby="home-tab"
                                        >
                                            {loadingStudentStudyMaterialVideoListApi ?
                                                <Beatloader />
                                                :
                                                <div className="row">
                                                    {StudentStudyMaterialVideoListApiData?.length > 0 ?
                                                        currentData?.map((data) => (
                                                            <div className="col-lg-6 mt-3 col-md-6">
                                                                <div
                                                                    className="card input-card-form notescard"
                                                                    style={{ backgroundColor: "aliceblue" }}
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#videoModal"
                                                                    onClick={() => { handleVideoClick(data?.material_file) }}
                                                                >
                                                                    <div className="card-body">
                                                                        <div className="row gap-0">
                                                                            <div className="col-lg-4 justify-content-center d-flex col-md-4 col-sm-4">
                                                                                {/* Trigger button for modal */}
                                                                                <img
                                                                                    src="/assets/img/user/play.png"
                                                                                    className="img-fluid play-button"
                                                                                    style={{
                                                                                        height: 85,
                                                                                        width: "auto",
                                                                                        borderRadius: 15,
                                                                                        cursor: "pointer"
                                                                                    }}
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#videoModal"
                                                                                />
                                                                            </div>
                                                                            <div className="col-lg-8 m-0 p-0 d-flex flex-column text-center justify-content-center col-md-8 col-sm-8 ">
                                                                                <h5 className="mb-0 text-dark text-center">
                                                                                    {data?.study_material?.material_name}
                                                                                </h5>
                                                                                <p className="mb-0">{new Date(data?.createdAt).toDateString()}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                        :
                                                        <div className='no-data-img'>
                                                            <img width={100} src="/assets/img/user/no-data.png" alt="" srcset="" />

                                                        </div>}

                                                </div>

                                            }
                                            {/* <nav aria-label="Page navigation">
                                                <ul className="pagination justify-content-center">
                                                   
                                                    <li className="page-item disabled">
                                                        <a
                                                            className="page-link"
                                                            href="#"
                                                            tabIndex={-1}
                                                            aria-disabled="true"
                                                            aria-label="Previous"
                                                        >
                                                            <i className="bi bi-chevron-left" />
                                                        </a>
                                                    </li>
                                                   
                                                    <li className="page-item">
                                                        <a className="page-link" href="#">
                                                            1
                                                        </a>
                                                    </li>
                                                    <li className="page-item active" aria-current="page">
                                                        <a className="page-link" href="#">
                                                            2
                                                        </a>
                                                    </li>
                                                    
                                                    <li className="page-item">
                                                        <a className="page-link" href="#" aria-label="Next">
                                                            <i className="bi bi-chevron-right" />
                                                        </a>
                                                    </li>
                                                </ul>
                                            </nav> */}

                                            {pageCount > 1 && (
                                                <ResponsivePagination
                                                    pageCount={pageCount}
                                                    currentPage={currentPage}
                                                    handlePageClick={handlePageClick}
                                                />
                                            )}
                                            {/* CSS for styling the pagination */}
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n                                        .pagination .page-item .page-link {\n                                            border: none;\n                                            margin: 0 5px;\n                                            padding: 10px 15px;\n                                            color: #555;\n                                            font-weight: 500;\n                                            font-size: 1rem;\n                                            border-radius: 8px;\n                                            transition: all 0.3s ease;\n                                            background-color: #f1f3f5;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n                                        }\n                                    \n                                        /* Hover effect */\n                                        .pagination .page-item .page-link:hover {\n                                            background-color: #e0e4e7;\n                                            color: #333;\n                                            box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n                                            transform: translateY(-2px);\n                                        }\n                                    \n                                        /* Active page styling */\n                                        .pagination .page-item.active .page-link {\n                                            background-color: #007bff;\n                                            color: #fff;\n                                            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n                                        }\n                                    \n                                        /* Disabled button styling */\n                                        .pagination .page-item.disabled .page-link {\n                                            color: #aaa;\n                                            background-color: #f1f3f5;\n                                            pointer-events: none;\n                                        }\n                                    \n                                        /* Chevron icon styling */\n                                        .pagination .page-item .page-link i {\n                                            font-size: 1rem;\n                                        }\n                                    "
                                                }}
                                            />
                                        </div>
                                        {/* <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                              <div class="row">
                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>

                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a style="padding-inline: 35px;"
                                                              class="btn btn-primary py-1 mt-1"
                                                              href="./student-one-to-one-chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="col-lg-6 mt-3 col-md-6">
                                      <div class="card input-card-form bg-white">
                                          <div class="card-body">
                                              <div class="row">

                                                  <div class="col-lg-4">
                                                      <img src="/assets/img/user/user5.jpg"
                                                          class="img-fluid rounded-circle"
                                                          style="height: 7.6rem; width: 100%;" />
                                                  </div>
                                                  <div class="col-lg-8">
                                                      <h5 class="mb-0 text-dark">Annu Yadav</h5>
                                                      <p class="mb-0">Biology</p>
                                                      <p class="mb-0">2 Year experience</p>
                                                      <div class="star">
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i
                                                                  class="fa-solid fa-star text-warning"></i></span>
                                                          <span><i class="fa-solid fa-star"></i></span>
                                                          <span>4.0 <span class="text-primary">(4.0
                                                                  Ratings)</span>
                                                      </div>

                                                      <div class="student_coursebtns d-flex gap-3">
                                                          <a class="btn btn-primary py-1 mt-1 "
                                                              style="padding-inline: 35px;" href="./chat.html">

                                                              Chat
                                                          </a>
                                                          <a class="btn btn-outline-primary py-1 mt-1"
                                                              href="./student-mycourse-group-view-details.html">

                                                              View Details
                                                          </a>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div> */}
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>
            <>
                {/* video popup */}
                <div
                    className="modal fade"
                    id="videoModal"
                    tabIndex={-1}
                    aria-labelledby="videoModalLabel"
                    aria-hidden="true"
                    data-bs-backdrop="static"
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="videoModalLabel">
                                    Notes Video
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                />
                            </div>
                            <div className="modal-body">
                                <div className="ratio ratio-16x9">

                                    <video
                                        className="d-none d-md-block d-lg-block d-xl-block img-fluid w-100"
                                        src={video}

                                        controls
                                        playsInline
                                        loading="eager"
                                    >
                                        Your browser does not support the video tag.
                                    </video>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>

        </div>
    )
}

export default StudentVideoNotes